import { css, Theme } from '@emotion/react'

export const textArea = (theme: Theme) => css`
  min-height: 69px;
  padding: 14px;
  font-family: ${theme.fonts.family.PlusJakartaSans};
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  border-radius: 14px;

  color: ${theme.typographyColors.typographyTwo};
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};

  :focus-visible {
    border: 1px solid ${theme.colors.blue};
    outline: none;
  }

  ::placeholder {
    font-family: ${theme.fonts.family.PlusJakartaSans};
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.typographyColors.typographyThree};
  }

  :disabled {
    color: rgba(0, 0, 0, 0.38);
  }
`

export const textAreaError = (theme: Theme) => css`
  border: 1px solid ${theme.colors.red};

  :focus-visible {
    border: 1px solid ${theme.colors.red};
    outline: none;
  }
`

export const textAreaHelperText = (theme: Theme) => css`
  margin-top: 10px;
  color: ${theme.colors.red};
`
